<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xdPRcG/tc-custom/9781682303573.jpg?1705766094863" alt="This image is the cover for the book Club"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Club
      </h1>
      <p class="bookDescription body article font2">
        <b>When a golf club’s first single female member is murdered, spunky club wife Judy Mills takes a swing at sleuthing in this “witty, well-plotted” mystery (<i>Publishers Weekly</i>).</b><br/>  <br/> Judy Mills has it all: A handsome husband, a thriving career, and a landmark house on two sylvan acres. But when Judy is downsized by her company, her husband suggests she networks with members at The Oaks, the country club he reveres and she abhors.<br/>  <br/> Judy knows the misogyny at the antiquated club is all par for the course, but she finds an unexpected ally in Claire Cox, a staunch feminist who has broken the club’s ironclad rule against admitting single women. There are other things about The Oaks that Claire intends to change—until she’s found dead in a sand trap on the golf course.<br/>  <br/> When ruggedly handsome Det. Tom Cunningham asks Judy to secretly investigate, she agrees to shed the role of complacent club wife to become an amateur sleuth. One willing to risk her life to bring a killer to justice, and just maybe bring her golf-obsessed husband to his senses . . .<br/>  <br/> “Heller delivers perfect reading for the beach—or pool-side at the club.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jane Heller
      </h2>
      
      <p class="authorDescription body article">Jane Heller is the New York Times and USA Today bestselling author of over a dozen titles, including hits like Female Intelligence, Name Dropping, and Some Nerve. She has been translated into several languages, and nine of her novels were sold to Hollywood for film/TV. Also known for her non-fiction titles, You’d Better Not Die Or I’ll Kill You and Confessions of a She-Fan, Heller has been critically adored for over two decade</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e536be3e